import { render } from "./Filterable-Attribute.vue?vue&type=template&id=2cc07857&scoped=true"
import script from "./Filterable-Attribute.vue?vue&type=script&lang=js"
export * from "./Filterable-Attribute.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2cc07857"

export default script